import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import SBoxTable from "./sbox";

const Page4 = (rond) => {
  const navigate = useNavigate();
  const location = useLocation();
  const allResults = location.state.allResults;
  const userInput = location.state.userInput;
  const userKey = location.state.userKey;
  let hexInput = userKey;
  const allEncResults = location.state.allEncResults;
  console.log("allEncResults", allEncResults);
  const cols = location.state.cols;

  let { round } = rond;
  round = round - 1;
  round = round / 4;

  const firstpage = () => {
    navigate("/page3", {
      state: { allResults, allEncResults, userInput, userKey, cols },
    });
  };

  const secondpage = () => {
    navigate("/page5");
  };

  const icon = {
    hidden: {
      x: -700,
    },
    visible: {
      x: 0,
      transition: {
        delay: 0.25,
        duration: 1,
      },
    },
  };

  let data = allEncResults[1][round].toString().split(" ");
  console.log("data", data);

  let cols2 = [
    [data.slice(0, 4)],
    [data.slice(4, 8)],
    [data.slice(8, 12)],
    [data.slice(12, 16)],
  ];

  const renderTable2 = () => {
    const table = [];

    for (let i = 0; i < 4; i++) {
      const row = [];
      for (let j = 0; j < 4; j++) {
        row.push(
          <td key={j} className="px-4 py-4 whitespace-nowrap">
            <div className="text-sm text-gray-900">{cols2[j][0][i]}</div>
          </td>
        );
      }
      table.push(<tr key={i}>{row}</tr>);
    }

    return table;
  };

  return (
    <>
      <div class="fixed top-16 right-8 h-4/5 w-1/6 rounded-xl bg-emerald-100 shadow p-4">
        <div class="text-center">
          <h2 className="text-xl pb-10 pt-4 font-semibold">
            How the Rows are Shifted
          </h2>
          <p class="text-sm">
            The first row is not shifted.
            <br />
            <br />
            The second row is shifted one (byte) position to the right.
            <br />
            <br />
            The third row is shifted two positions to the right.
            <br />
            <br />
            The fourth row is shifted three positions to the right.
            <br />
            <br />
            <strong>Note: All these shifts are Circular right shifts.</strong>
          </p>
        </div>
      </div>
      <div className="input-container">
        <div className="flex flex-col items-center">
          <div>
            <h2 className=" font-semibold text-2xl">Round {round + 1}</h2>
            <h2 className=" font-semibold text-xl">Step 2</h2>
            <h2 className=" font-semibold text-xl">Shift Rows(Right Shift)</h2>

            <div className="grid grid-flow-col grid-cols-4 gap-2 align-middle pt-28">
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 2 }}
                className="w-fit"
              >
                <table className=" bg-emerald-100 rounded-xl w-auto">
                  <tbody className="">{renderTable2()}</tbody>
                </table>
                <p className="align-middle"> After S-box substition</p>
              </motion.div>

              <div className=" pt-20 pl-7">
                <svg
                  width="170"
                  height="38"
                  viewBox="0 0 573 38"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <motion.path
                    variants={icon}
                    initial="hidden"
                    animate="visible"
                    d="M571.771 20.7678C572.748 19.7915 572.748 18.2085 571.771 17.2322L555.861 1.32233C554.885 0.34602 553.302 0.34602 552.326 1.32233C551.349 2.29864 551.349 3.88155 552.326 4.85786L566.468 19L552.326 33.1421C551.349 34.1184 551.349 35.7014 552.326 36.6777C553.302 37.654 554.885 37.654 555.861 36.6777L571.771 20.7678ZM0 21.5H570.003V16.5H0V21.5Z"
                    fill="black"
                  />
                </svg>
              </div>

              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 2 }}
                className="w-fit"
              >
                <table className=" bg-emerald-100 rounded-xl w-auto">
                  <tbody className="">
                    <tr>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900 ">
                          {allEncResults[2][round][0]
                            .map((item) => item.split("").join(""))
                            .join(" \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0")}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <motion.div
                          initial={{ opacity: 0.4, x: -400 }}
                          animate={{ opacity: 1, x: -10 }}
                          transition={{ delay: 1.5, duration: 1.5 }}
                          className="text-sm text-gray-900"
                        >
                          {allEncResults[2][round][1]
                            .map((item) => item.split("").join(""))
                            .join(" \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0")
                            .slice(0, 25)}
                        </motion.div>
                        <motion.div
                          initial={{ opacity: 0.4, x: -490, y: -22 }}
                          animate={{ opacity: 1, x: 58, y: -22 }}
                          transition={{ delay: 2, duration: 1.5 }}
                        >
                          {allEncResults[2][round][1]
                            .map((item) => item.split("").join(""))
                            .join(" ")
                            .slice(9, 13)}
                        </motion.div>
                      </td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <motion.div
                          initial={{ opacity: 0.4, x: -360, y: -25 }}
                          animate={{ opacity: 1, x: -35, y: 0 }}
                          transition={{ delay: 3.5, duration: 1.5 }}
                          className="text-sm text-gray-900"
                        >
                          {allEncResults[2][round][2]
                            .map((item) => item.split("").join(""))
                            .join(" \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0")
                            .slice(0, 15)}
                        </motion.div>
                        <motion.div
                          initial={{ opacity: 0.4, x: -460, y: -45 }}
                          animate={{ opacity: 1, x: 40, y: -22 }}
                          transition={{ delay: 4, duration: 1.5 }}
                        >
                          {allEncResults[2][round][2]
                            .map((item) => item.split("").join(""))
                            .join("\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0")
                            .slice(15, 26)}
                        </motion.div>
                      </td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <motion.div
                          initial={{ opacity: 0.4, x: -330, y: -45 }}
                          animate={{ opacity: 1, x: -60, y: 0 }}
                          transition={{ delay: 3.5, duration: 1.5 }}
                          className="text-sm text-gray-900"
                        >
                          {allEncResults[2][round][3]
                            .map((item) => item.split("").join(""))
                            .join(" \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0")
                            .slice(0, 5)}
                        </motion.div>
                        <motion.div
                          initial={{ opacity: 0.4, x: -440, y: -70 }}
                          animate={{ opacity: 1, x: 20, y: -22 }}
                          transition={{ delay: 4, duration: 1.5 }}
                        >
                          {allEncResults[2][round][3]
                            .map((item) => item.split("").join(""))
                            .join("\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0")
                            .slice(5, 26)}
                        </motion.div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p className="align-middle"> After Shifted Rows</p>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
      {/* <div class="button-holder">
        <div class="prev-button" onClick={firstpage}>
          PREVIOUS
        </div>
        <div className="next-button" onClick={secondpage}>
          NEXT
        </div>
      </div> */}
    </>
  );
};

export default Page4;
